import {createApp} from 'vue'
import App from './App.vue'
import {store} from "@/store/vuexStore";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueMitter from '@nguyenshort/vue3-mitt'
import VueMobileDetection from "vue-mobile-detection";
import VueCookies from 'vue3-cookies'

let inJsonEl = document.getElementById('cabData');
var searchDataForm = inJsonEl ? JSON.parse(inJsonEl.textContent) : {};

store.commit('setCabData', searchDataForm, {root: true})

let app = createApp(App)
app.use(VueMobileDetection);
app.use(VueCookies);
app.use(VueMitter)
app.use(store)
app.use(Toast, {
    // timeout: false,
    // For the actual toast, including different toast types:
    hideProgressBar: true,
    toastClassName: "custom-toast-class",

    // For the toast body when using strings or a custom component as content
    // bodyClassName: ["custom-class-1", "custom-class-2"]
})
app.mount('#app')
